/*
 * @Version: 1.2
 * @Author: admin
 * @Description: permission
 * @Date: 2022-06-23 14:44:40
 * @LastEditors: sky
 * @LastEditTime: 2022-09-15 11:42:44
 */
import { DirectiveBinding } from "vue";
import { useUserStore } from "@/store";

function checkPermission(el: HTMLElement, binding: DirectiveBinding) {
  const { value } = binding;
  const userStore = useUserStore();
  const { permissions } = userStore;
  const all_permission = "*:*:*";
  if (Array.isArray(value)) {
    if (value.length > 0) {
      const permissionValues = value;
      if (permissions.length == 1 && all_permission === permissions[0]) {
        return;
      }
      const hasPermission = permissions.includes(permissionValues[0]);
      if (!hasPermission && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  } else {
    throw new Error(`need roles! Like v-permission="['admin','user']"`);
  }
}

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    checkPermission(el, binding);
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    checkPermission(el, binding);
  },
};
